import React, { useState } from 'react';
import {
	Modal,
	ModalBody,
	ModalFooter,
	TabContent,
	TabPane,
	Nav
} from 'reactstrap';
import {
	TabsNavigation,
	NavLinkStyled,
	NavItemStyled,
	ButtonStyle,
	ButtonStyleOk
} from './styles';
import PdfChargBack from '../../../../../assets/pdf/PoliticaChargeback.pdf';
import PdfContrato from '../../../../../assets/pdf/ContratoDeCredenciamentoEAdesaoDeEstabelecimentos.pdf';

import { Termo } from './termo';
import { Contrato } from './contrato';

export function ModalDoc(props) {
	const { isOpen, toggle } = props;

	const onButtonClick = (tabAtiva) => {
		// using Java Script method to get PDF file
		fetch(tabAtiva === 'termo' ? PdfChargBack : PdfContrato).then(response => {
			response.blob().then(blob => {
				// Creating new object of PDF file
				const fileURL = window.URL.createObjectURL(blob);
				// Setting various property values
				const alink = document.createElement('a');
				alink.href = fileURL;
				alink.download = tabAtiva === 'termo' ? PdfChargBack : PdfContrato;
				alink.click();
			})
		})
	}

	const [tabAtiva, setTabAtiva] = useState('termo');

	return (
		<Modal size="lg" style={{ maxWidth: '1040px', width: '100%', height: '100%' }} isOpen={isOpen} toggle={toggle}>
			<ModalBody>
				<p>
					Termo e Contrato
					{' '}
					<b>Nº 3020.2736</b>
				</p>
				<TabsNavigation className="mt-5">
					<div className="nav-tabs-wrapper mb-0">
						<Nav tabs className="justify-content-start">
							<NavItemStyled>
								<NavLinkStyled
									active={tabAtiva === 'termo'}
									onClick={() => {
										setTabAtiva('termo');
									}}>
									Termo
								</NavLinkStyled>
							</NavItemStyled>
							<NavItemStyled>
								<NavLinkStyled
									active={tabAtiva === 'contrato'}
									onClick={() => {
										setTabAtiva('contrato');
									}}>
									Contrato
								</NavLinkStyled>
							</NavItemStyled>
						</Nav>
					</div>
				</TabsNavigation>
				<TabContent activeTab={tabAtiva}>
					<TabPane tabId="termo">
						<Termo />
					</TabPane>
					<TabPane tabId="contrato">
						<Contrato />
					</TabPane>
				</TabContent>

			</ModalBody>
			<ModalFooter>
				<ButtonStyle color="primary" onClick={() => onButtonClick(tabAtiva)}>
					DOWNLOAD
				</ButtonStyle>
				<ButtonStyleOk color="primary" onClick={toggle}>
					OK
				</ButtonStyleOk>
			</ModalFooter>
		</Modal>
	);
}


